import { type FC, type ComponentProps, type ReactNode } from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link.tsx';
import { HpSharedViewMoreLink } from '../HpSharedViewMoreLink/HpSharedViewMoreLink.tsx';

import styles from './HpSharedHeader.scss';
import dibsCss from 'dibs-css';

type Props = {
    title?: ReactNode;
    subtitle?: ReactNode;
    viewMoreLink?: string | null;
    viewMoreText?: ReactNode;
    onViewMoreClick?: ComponentProps<typeof Link>['onClick'];
    dataTn?: string;
    size?: 'large' | 'larger';
    align?: 'center' | 'left';
};

export const HpSharedHeader: FC<Props> = ({
    title,
    subtitle,
    viewMoreLink,
    viewMoreText,
    onViewMoreClick,
    dataTn,
    size = 'large',
    align = 'center',
}) => {
    const titleComponent =
        title && subtitle ? (
            <FormattedMessage
                id="HpSharedCarouselTabs.title.responsive"
                defaultMessage="{title}: {subtitle}"
                values={{
                    title: title,
                    subtitle: (
                        <span className={dibsCss.sassyFontHeaderXLargeItalic}>{subtitle}</span>
                    ),
                }}
            />
        ) : (
            title
        );

    return title ? (
        <div
            className={classnames(
                styles.headerContainer,
                styles[size],
                size === 'larger' && [dibsCss.mLarger, dibsCss.textNoir],
                {
                    [dibsCss.textCenter]: align === 'center',
                    [dibsCss.mLarge]: size === 'large',
                    [dibsCss.mbMedium]: size === 'larger' && !viewMoreLink,
                },
                align === 'left' && [styles.left, dibsCss.textLeft]
            )}
        >
            <div className={classnames(styles.titleWrapper, {})}>
                <div
                    className={classnames(
                        styles.title,
                        styles[size],
                        dibsCss.sassyFontHeaderSizeXLarge,
                        {
                            [dibsCss.textNoir]: size === 'larger',
                        }
                    )}
                    data-tn={dataTn ? `${dataTn}-title` : null}
                >
                    {titleComponent}
                </div>
                {viewMoreLink && (
                    <HpSharedViewMoreLink
                        viewMoreLink={viewMoreLink}
                        viewMoreText={viewMoreText}
                        onViewMoreClick={onViewMoreClick}
                        size={size}
                        dataTn={dataTn}
                    />
                )}
            </div>
        </div>
    ) : null;
};
